import React from 'react';
import { 
  MessageSquare, 
  Users, 
  Target, 
  Zap, 
  Heart, 
  TrendingUp 
} from 'lucide-react';

const situations = [
  {
    icon: MessageSquare,
    quote: "My manager gives vague feedback and I don't know what to fix",
    category: 'Expectation clarity',
    color: 'red'
  },
  {
    icon: Users,
    quote: "A senior dev dismisses my suggestions in meetings",
    category: 'Stakeholder dynamics',
    color: 'purple'
  },
  {
    icon: Target,
    quote: "I'm not sure what success looks like in this new role",
    category: 'Role clarity',
    color: 'blue'
  },
  {
    icon: Zap,
    quote: "Two team members don't work well together",
    category: 'Team friction',
    color: 'orange'
  },
  {
    icon: Heart,
    quote: "Need to give difficult feedback to someone I like",
    category: 'Hard conversation',
    color: 'pink'
  },
  {
    icon: TrendingUp,
    quote: "Everyone's busy but nothing gets finished",
    category: 'Execution',
    color: 'green'
  }
];

const RelatableSituations = ({ series }) => {
  const accentColor = series?.accentColor || '#dc2626';

  const scrollToDemo = () => {
    const demoSection = document.getElementById('clarity-demo');
    if (demoSection) {
      demoSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-slate-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-14">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            Situations people bring to us
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Sound familiar? You're not alone. These are the kinds of things we help people think through every day.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {situations.map((situation, index) => {
              const Icon = situation.icon;
              return (
                <button
                  key={index}
                  onClick={scrollToDemo}
                  className="bg-white p-6 rounded-2xl border border-slate-200 hover:border-slate-300 hover:shadow-lg transition-all text-left group"
                  data-testid={`situation-card-${index}`}
                >
                  <div 
                    className="w-10 h-10 rounded-xl flex items-center justify-center mb-4"
                    style={{ backgroundColor: `${accentColor}10` }}
                  >
                    <Icon className="w-5 h-5" style={{ color: accentColor }} />
                  </div>
                  <p className="text-slate-700 font-medium mb-3 group-hover:text-slate-900 transition-colors">
                    "{situation.quote}"
                  </p>
                  <span 
                    className="text-xs font-medium px-2.5 py-1 rounded-full"
                    style={{ 
                      backgroundColor: `${accentColor}10`,
                      color: accentColor
                    }}
                  >
                    {situation.category}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        <div className="text-center mt-12">
          <button
            onClick={scrollToDemo}
            className="inline-flex items-center gap-2 px-8 py-4 text-white font-semibold rounded-xl transition-all shadow-lg hover:shadow-xl"
            style={{ backgroundColor: accentColor }}
            data-testid="situations-cta"
          >
            Describe your situation
            <span className="text-xl">→</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default RelatableSituations;
